export default __webpack_public_path__ + "static/media/mainHero.927df105.png";